import { T, useI18n } from '../lib/i18n'
import { Check, LifeBuoy, Mail, Send } from 'lucide-react'
import { useState, type FormEvent } from 'react'
import { Link } from 'react-router-dom'
import { toast } from 'sonner'
import { Logo } from '../components/Logo'
import { useAuth } from '../context/AuthContext'
import { supabase } from '../lib/supabase'

export function SupportPage() {
  const { session } = useAuth()
  const { t } = useI18n()
  const [category, setCategory] = useState('technical')
  const [subject, setSubject] = useState('')
  const [message, setMessage] = useState('')
  const [sending, setSending] = useState(false)
  const valid = subject.trim().length >= 3 && message.trim().length >= 10

  async function submit(event: FormEvent) {
    event.preventDefault()
    if (!session || !valid || sending) return
    setSending(true)
    const { data, error } = await supabase.rpc('create_support_ticket', {
      target_category: category,
      target_subject: subject.trim(),
      target_message: message.trim(),
      target_organization_id: null,
    })
    if (error) {
      toast.error(t(error.message))
      setSending(false)
      return
    }
    const ticketId = String(data)
    await supabase.functions.invoke('dispatch-support-email', { body: { ticket_id: ticketId } }).catch(() => undefined)
    setSending(false)
    setSubject('')
    setMessage('')
    toast.success(t('Support request saved · {ticket}', { ticket: ticketId.slice(0, 8).toUpperCase() }))
  }

  return (
    <main className="support-page">
      <header className="legal-header"><Logo /><nav><Link to="/"><T>{"TidyPing"}</T></Link><Link to="/help"><T>{"Help & tutorials"}</T></Link><Link to="/legal/privacy"><T>{"Privacy"}</T></Link><Link to="/legal/terms"><T>{"Terms"}</T></Link></nav></header>
      <section className="support-hero">
        <span className="support-hero__icon"><LifeBuoy size={30} /></span><span className="eyebrow"><T>{"TidyPing support"}</T></span><h1><T>{"Real help for your workspace"}</T></h1><p><T>{"Send a secure request below or email our support mailbox directly."}</T></p>
        <a className="button button--secondary" href="mailto:support@maintechsolution.com?subject=TidyPing%20Support"><Mail size={17} /><T>{"support@maintechsolution.com"}</T></a>
      </section>
      {session ? (
        <form className="support-form surface" onSubmit={submit}>
          <label><span><T>{"Category"}</T></span><select value={category} onChange={(event) => setCategory(event.target.value)}><option value="technical"><T>{"Technical issue"}</T></option><option value="account"><T>{"Account access"}</T></option><option value="billing"><T>{"Plan or billing"}</T></option><option value="privacy"><T>{"Privacy request"}</T></option><option value="feedback"><T>{"Product feedback"}</T></option><option value="other"><T>{"Other"}</T></option></select></label>
          <label><span><T>{"Subject"}</T></span><input value={subject} onChange={(event) => setSubject(event.target.value)} maxLength={160} /></label>
          <label><span><T>{"Message"}</T></span><textarea rows={8} value={message} onChange={(event) => setMessage(event.target.value)} maxLength={5000} /></label>
          <p><Check size={15} /><T>{"Your request is saved before email delivery, so it will not be lost."}</T></p>
          <button className="button button--primary" disabled={!valid || sending}>{sending ? t('Sending…') : t('Send support request')}<Send size={17} /></button>
        </form>
      ) : (
        <section className="support-signin surface"><h2><T>{"Already use TidyPing?"}</T></h2><p><T>{"Sign in first to create a tracked support ticket tied to your account."}</T></p><Link className="button button--primary" to="/signin"><T>{"Sign in securely"}</T></Link></section>
      )}
    </main>
  )
}
